import { createApp } from 'vue';
import DjlEvents from '../calendar/djl_events.vue';

const sortByStart = arr => [...arr].sort((a, b) => (a.start_at || '').localeCompare(b.start_at || ''));

document.addEventListener('DOMContentLoaded', () => {
  const mountEl = document.getElementById('djl_events');
  const dataEl = document.getElementById('serverData');
  if (!mountEl || !dataEl) return;

  const initialEvents = sortByStart((JSON.parse(dataEl.textContent).events || []));

  const app = createApp(DjlEvents, { events: initialEvents });
  app.mount(mountEl);
});
